import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const CurrentLevelStyle = {
  wrapper: css`
    padding-bottom: 20px;
    position: relative;
    width: fit-content;
    img {
      width: 450px;
    }
    ${media.sm} {
      padding-bottom: 15px;
      img {
        width: 300px;
      }
    }
  `,

  currentVipTextBox: {
    index: css`
      position: absolute;
      top: 60px;
      left: 20px;
      width: 60%;
      text-shadow:
        -1px -1px 0 #000,
        1px -1px 0 #000,
        -1px 1px 0 #000,
        1px 1px 0 #000;

      color: ${theme.colors.white};
      h4 {
        font-size: 18px;
        margin: 10px 0;
        font-family: inherit;
        font-weight: 500;
        line-height: 1.1;
        color: inherit;
      }

      ${media.sm} {
        top: 30px;
        left: 15px;
        h4 {
          margin: 0;
          font-size: 14px;
        }
      }
    `,
    mainLv: css`
      font-weight: bold;
      font-size: 36px;
      margin: 20px 0 10px 0;
      ${media.sm} {
        margin: 0;
        font-size: 50px;
      }
    `,

    subLv: css`
      font-weight: bold;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      line-height: 20px;
      word-break: break-all;
      ${media.sm} {
        margin: 0;
      }
    `,
  },
};
